import SuperPromptApp from './SuperPromptApp';

function App() {
  return (
    <div className="App">
      <SuperPromptApp />
    </div>
  );
}

export default App;